export const EMAIL_PROVIDERS = {
  SMTP: 'smtp',
  GMAIL: 'gmail',
  MICROSOFT: 'microsoft',
} as const

export type EmailProvider = typeof EMAIL_PROVIDERS[keyof typeof EMAIL_PROVIDERS]

export const EMAIL_PROVIDER_LABELS = {
  [EMAIL_PROVIDERS.SMTP]: 'SMTP (Eigen e-mailserver)',
  [EMAIL_PROVIDERS.GMAIL]: 'Gmail (Google OAuth)',
  [EMAIL_PROVIDERS.MICROSOFT]: 'Microsoft (OAuth)',
}

export const EMAIL_PROVIDER_OPTIONS = Object.entries(EMAIL_PROVIDER_LABELS).map(([value, label]) => ({
  value,
  label,
}))
